import {NgModule, OnInit} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {BrowserModule}  from '@angular/platform-browser';
import {HttpClientModule}    from '@angular/common/http';

import {JwtModule} from '@auth0/angular-jwt';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {ChartsModule} from "ng2-charts";
import {Ng2SearchPipeModule} from 'ng2-search-filter';
import {NgHcaptchaModule} from 'ng-hcaptcha';

import {AppRoutingModule} from './app-routing.module';
import {AlreadyLoggedIn} from "./services/route-can-activates/already-logged-in.service";
import {AuthenticationGuard} from "./services/route-can-activates/authentication-guard.service";
import {AuthenticationService} from "./services/authentication.service";

import {CloudApiService} from "./services/cloud-api.service";
import {UserSessionService} from "./services/user-session.service";
import {UtilitiesService} from "./services/utilities.service";

import {SelectLibraryModal, SelectLibraryModalComponent} from "./components/modals/select-library/select-library.modal.component";
import {AddPortalLinkModal, AddPortalLinkModalComponent} from "./components/modals/add-portal-link/add-portal-link.modal.component";
import {UserManagementModal, UserManagementModalComponent} from "./components/modals/user-management/user-management.modal.component";
import {DeploymentConfirmationModal, DeploymentConfirmationModalComponent} from "./components/modals/deployment-confirmation/deployment-confirmation.modal.component";
import {UninstallServicesConfirmationModal, UninstallServicesConfirmationModalComponent} from "./components/modals/uninstall-services-confirmation/uninstall-services-confirmation.modal.component";

import {AppComponent} from './components/app.component';
import {LoginComponent} from "./components/login/login.component";
import {PasswordResetComponent} from "./components/password-reset/password-reset.component";
import {PasswordResetCreateComponent} from "./components/password-reset-create/password-reset-create.component";
import {DashboardComponent} from "./components/dashboard/dashboard.component";
import {OccupancyComponent} from "./components/occupancy/occupancy.component";
import {AlarmComponent} from "./components/alarms/alarm.component";
import {ReportsComponent} from "./components/reports/reports.component";
import {ReportTableComponent} from "./components/reports/report-table/report-table.component";
import {ReportBodyComponent} from "./components/reports/report-body/report-body.component";
import {REPORT_REGISTRY, REPORTS} from "./reports/report-registry";
import {LinkPortalComponent} from "./components/link-portal/link-portal.component";
import {DeploymentComponent} from "./components/deployment/deployment.component";
import {DeploymentTreeComponent} from "./components/deployment/deployment-tree/deployment-tree.component";
import {DeploymentBatchPreviewComponent} from "./components/modals/deployment-confirmation/deployment-batch-preview/deployment-batch-preview.component";
import {LicenceManagementComponent} from "./components/licence-mangement/licence-management.component";

import {MatRadioModule} from "@angular/material/radio";
import {MatDatepickerModule} from "@angular/material/datepicker";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatNativeDateModule} from "@angular/material/core";
import {MatInputModule} from "@angular/material/input";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";
import {DatePipe} from "@angular/common";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatSelectModule} from "@angular/material/select";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {DeploymentUtilitiesService} from "./services/deployment-utilities.service";
import {TotesComponent} from "./components/totes/totes.component";
import {NgSelectModule} from "@ng-select/ng-select";

@NgModule({
    imports: [
        BrowserModule,
        FormsModule,
        HttpClientModule,
        JwtModule.forRoot({
            config: {
                tokenGetter: () => localStorage.getItem('accessToken'),
                whitelistedDomains: ['localhost:7071', 'localhost:44301', 'api.fetechgroup.com', 'cloud.fetechgroup.com'],
            }
        }),
        NgbModule.forRoot(),
        AppRoutingModule,
        ChartsModule,
        ReactiveFormsModule,
        NgHcaptchaModule.forRoot(),
        Ng2SearchPipeModule,
        MatRadioModule,
        MatDatepickerModule,
        MatFormFieldModule,
        MatNativeDateModule,
        MatInputModule,
        MatCheckboxModule,
        BrowserAnimationsModule,
        MatExpansionModule,
        MatSelectModule,
        MatAutocompleteModule,
        NgSelectModule
    ],
    declarations: [
        AppComponent,
        LoginComponent,
        LicenceManagementComponent,
        PasswordResetComponent,
        PasswordResetCreateComponent,
        DashboardComponent,
        OccupancyComponent,
        AlarmComponent,
        ReportsComponent,
        ReportTableComponent,
        ReportBodyComponent,
        SelectLibraryModalComponent,
        LinkPortalComponent,
        DeploymentComponent,
        DeploymentTreeComponent,
        DeploymentBatchPreviewComponent,
        AddPortalLinkModalComponent,
        UserManagementModalComponent,
        DeploymentConfirmationModalComponent,
        UninstallServicesConfirmationModalComponent,
        TotesComponent
    ],
    entryComponents: [
        SelectLibraryModalComponent,
        AddPortalLinkModalComponent,
        UserManagementModalComponent,
        DeploymentConfirmationModalComponent,
        UninstallServicesConfirmationModalComponent
    ],
    providers: [
        AlreadyLoggedIn, AuthenticationGuard,
        UserSessionService,
        AuthenticationService,
        CloudApiService,
        UtilitiesService,
        DeploymentUtilitiesService,
        SelectLibraryModal,
        AddPortalLinkModal,
        UserManagementModal,
        DeploymentConfirmationModal,
        UninstallServicesConfirmationModal,
        DatePipe,
        { provide: REPORT_REGISTRY, useValue: REPORTS },
    ],
    bootstrap: [ AppComponent ]
})
export class AppModule implements OnInit {

    constructor(
        private authenticationService: AuthenticationService,
    ) {

    }

    ngOnInit(): void {

    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/app.module.ts